<template>
  <div>
    <user-actions-component></user-actions-component>
    <section class="bg-white py-5" aria-label="Saved searches">
      <b-container>
        <b-row>
          <b-col sm="12" md="12" lg="2">
            <back-button></back-button>
          </b-col>
          <b-col sm="12" md="12" lg="10">
            <h1 class="mb-3">Saved searches</h1>
            <b-list-group
              v-if="savedSearches.length > 0 && dataSet == true"
              class="saved-search-list"
            >
              <b-list-group-item
                v-for="(item, index) in savedSearches"
                :key="index"
                class="saved-search-list-item"
              >
                <div class="search-list-actions">
                  <b-button
                    v-for="(filter, ix) in JSON.parse(item.lozenges)"
                    :key="ix"
                    variant="outline-primary"
                    pill
                    size="sm"
                    class="mr-2"
                    disabled
                    >{{ getFilterData(filter) }}
                  </b-button>
                  <a
                    type="button"
                    class="btn-delete-search m-2"
                    @click="removeSaveSearch(item.id, index)"
                    >Delete search <span class="small"><b-icon icon="bookmark-dash"></b-icon></span>
                  </a>
                  <router-link
                    class="saved-searches m-2"
                    :to="{
                      path: '/',
                      query: formatQuery(item.search_settings),
                    }"
                    aria-label="View saved searches"
                  >
                    View search
                    <span class="small"><b-icon icon="bookmark-plus-fill"></b-icon></span>
                  </router-link>
                </div>
              </b-list-group-item>
            </b-list-group>
            <span v-if="savedSearches.length < 1"> You have not saved any searches </span>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import store from '@/store/'
import { mapState } from 'vuex'

import { FETCH_FILTERS_SETTINGS, FETCH_FILTER_DATA } from '@/store/actions.type.js'
import { SaveSearchCall } from '@/common/api.service'
import BackButton from '../elements/BackButton.vue'
import UserActionsComponent from '../elements/UserActionsComponent.vue'

export default {
  name: 'SavedSearches',
  components: {
    BackButton,
    UserActionsComponent,
  },
  data() {
    return {
      savedSearches: [],
      saving: false,
      dataSet: false,
    }
  },
  computed: {
    ...mapState(['searchFilters']),
  },
  async beforeMount() {
    await store.dispatch(FETCH_FILTERS_SETTINGS)
    this.savedSearches = await this.getSearches()
    this.dataSet = true
  },
  methods: {
    getFilterData(element) {
      // Get the filter data.
      const filData = this.searchFilters.filterSettings.find((fv) => fv.paramId == element.paramId)
      const label = filData.label
      // We check if filterData is string which means no array of data needed.
      if (typeof filData.filterData === 'string') return label + ' : ' + element.id
      // If data is needed get it.
      if (filData.filterData.length < 1 && filData.apiParamName) {
        store.dispatch(FETCH_FILTER_DATA, filData.apiParamName)
      }
      const filName = filData.filterData.find((fd) => {
        return fd.id == element.id
      })
      return filName ? label + ' : ' + filName.name : label + ' : ' + element.selected
    },
    async getSearches() {
      //if (this.logged === true) {
      if (this.saving === false) {
        const { data } = await SaveSearchCall.post({
          req_id: 'get_user_search',
        })
        return data
      }
      return []
      //}
    },
    formatQuery(searchSettings) {
      try {
        return JSON.parse(searchSettings)
      } catch (e) {
        console.log(e, searchSettings)
      }
    },
    async removeSaveSearch(searchId, index) {
      const { data } = await SaveSearchCall.post({
        req_id: 'delete_user_search',
        id: searchId,
      })
      this.savedSearches.splice(index, 1)
    },
  },
}
</script>
